export default "__VITE_ASSET__B0EEdp0Q__"